export default __webpack_public_path__ + "static/media/insta-icon-square-rounded.065377af.svg";